import React, { useState } from 'react';
import Button from '../../../../../../component/ui/Button';
import Modal from '../../../../../../component/modal/Modal';
import { toast } from 'react-toastify';
import { cancelSubscription } from '../../../../../../services/subscription';

export default function CancelSubscriptionReasonModal({
	isOpenModal,
	setIsOpenModal,
	showMessage,
	onCancelSuccess, // ← add this prop to refresh parent after cancel
}) {
	const [selectedReasonList, setSelectedReasonList] = useState([]);
	const [cancelling, setCancelling] = useState(false);

	const cancelSubscriptionReasonList = [
		{ id: 1, label: 'I am not using Pharmnex regularly' },
		{ id: 2, label: 'Pricing is too high' },
		{ id: 3, label: 'Facing technical issues' },
		{ id: 4, label: 'Missing required features' },
		{ id: 5, label: 'Found a better alternative' },
		{ id: 6, label: 'Other' },
		{ id: 7, label: 'Prefer not to say' },
	];

	const checked = (key) => selectedReasonList.includes(key);

	const toggle = (id) => {
		setSelectedReasonList((prev) =>
			prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id],
		);
	};

	// get reason labels from selected ids
	const getSelectedLabels = () => {
		return cancelSubscriptionReasonList
			.filter((r) => selectedReasonList.includes(r.id))
			.map((r) => r.label);
	};

	const handleCancel = async () => {
		if (selectedReasonList.length === 0) {
			toast.error('Please select at least one reason');
			return;
		}

		try {
			setCancelling(true);

			const response = await cancelSubscription({
				cancel_at_cycle_end: 1,
				reasons: getSelectedLabels(),
			});

			if (response.success) {
				setIsOpenModal(false);
				showMessage();
				onCancelSuccess?.();
			} else {
				toast.error(response.message ?? 'Failed to cancel subscription');
			}
		} catch (error) {
			console.error('cancel subscription error:', error);
			toast.error(error?.response?.data?.message ?? 'Failed to cancel subscription');
		} finally {
			setCancelling(false);
		}
	};

	return (
		<Modal
			className="subscription-modal"
			title="What is the reason for cancelling?"
			isOpen={isOpenModal}
			onClose={() => setIsOpenModal(false)}
			cancelButton={() => setIsOpenModal(false)}
		>
			<div>
				<div
					className="fs-5 fw-light rounded-3 px-5 py-4 text-dark"
					style={{ backgroundColor: 'rgba(230, 245, 255, 1)' }}
				>
					Before you cancel, please tell us why you are leaving. This will help us improve Pharmnex.
				</div>

				{cancelSubscriptionReasonList.map((item, i) => (
					<label
						key={i}
						className="d-flex gap-3 py-2 cursor-pointer"
					>
						<input
							type="checkbox"
							className="form-check-input cursor-pointer"
							checked={checked(item.id)}
							onChange={() => toggle(item.id)}
						/>
						{item.label}
					</label>
				))}

				<div className="d-flex justify-content-end align-items-center gap-4 my-4">
					<Button
						type="button"
						className="mt-0 bg-transparent text-primary border-primary rounded-4 fs-5 fw-light add-pro py-3 px-5"
						button="Back"
						onClick={() => setIsOpenModal(false)}
					/>
					<Button
						type="button"
						className="mt-0 btn-primary rounded-4 text-white fs-5 fw-light add-pro py-3 px-5"
						button={cancelling ? 'Cancelling...' : 'Continue'}
						loader={cancelling}
						disabled={cancelling}
						onClick={handleCancel}
					/>
				</div>
			</div>
		</Modal>
	);
}
